import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
const ALLOWED_MIMES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
const MAX_BYTES = 5 * 1024 * 1024;
export default class ListingImageUploader extends Component {
  dragOver = false;
  fileInput = null;
  view() {
    const max = this.attrs.max ?? 20;
    const total = this.attrs.uploaded.length + this.attrs.pending.length;
    const canAdd = total < max;
    return m("div", {
      className: "ListingImageUploader"
    }, m("div", {
      className: classList('ListingImageUploader-dropzone', this.dragOver && 'is-dragover', !canAdd && 'is-disabled'),
      ondragover: e => {
        e.preventDefault();
        if (!canAdd) return;
        this.dragOver = true;
      },
      ondragleave: () => {
        this.dragOver = false;
      },
      ondrop: e => {
        e.preventDefault();
        this.dragOver = false;
        if (!canAdd) return;
        const files = Array.from(e.dataTransfer?.files || []);
        this.acceptFiles(files);
      },
      onclick: e => {
        if (!canAdd) return;
        if (e.target.closest('.ListingImageUploader-thumb')) return;
        this.fileInput?.click();
      }
    }, m("input", {
      type: "file",
      multiple: true,
      accept: ALLOWED_MIMES.join(','),
      style: "display:none",
      oncreate: vnode => {
        this.fileInput = vnode.dom;
      },
      onchange: e => {
        const input = e.target;
        const files = Array.from(input.files || []);
        this.acceptFiles(files);
        input.value = '';
      }
    }), total === 0 ? m("div", {
      className: "ListingImageUploader-prompt"
    }, m("i", {
      className: "fas fa-camera",
      "aria-hidden": "true"
    }), m("span", {
      className: "ListingImageUploader-promptTitle"
    }, app.translator.trans('flarum-classifieds.forum.uploader.title')), m("span", {
      className: "ListingImageUploader-promptHint"
    }, app.translator.trans('flarum-classifieds.forum.uploader.hint', {
      max
    }))) : m("div", {
      className: "ListingImageUploader-grid"
    }, this.attrs.uploaded.map(url => m("div", {
      className: "ListingImageUploader-thumb",
      key: url
    }, m("img", {
      src: url,
      alt: "",
      loading: "lazy"
    }), m("button", {
      type: "button",
      className: "ListingImageUploader-thumbRemove",
      "aria-label": app.translator.trans('flarum-classifieds.forum.uploader.remove'),
      onclick: e => {
        e.stopPropagation();
        this.attrs.onRemoveUploaded?.(url);
      }
    }, m("i", {
      className: "fas fa-times",
      "aria-hidden": "true"
    })))), this.attrs.pending.map((p, i) => m("div", {
      className: classList('ListingImageUploader-thumb', 'ListingImageUploader-thumb--pending', p.uploaded && 'is-uploaded'),
      key: p.previewUrl
    }, m("img", {
      src: p.previewUrl,
      alt: ""
    }), !p.uploaded && m("span", {
      className: "ListingImageUploader-thumbPending",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-clock"
    })), m("button", {
      type: "button",
      className: "ListingImageUploader-thumbRemove",
      "aria-label": app.translator.trans('flarum-classifieds.forum.uploader.remove'),
      onclick: e => {
        e.stopPropagation();
        const next = this.attrs.pending.slice();
        next.splice(i, 1);
        try {
          URL.revokeObjectURL(p.previewUrl);
        } catch {}
        this.attrs.onChangePending(next);
      }
    }, m("i", {
      className: "fas fa-times",
      "aria-hidden": "true"
    })))), canAdd && m(Button, {
      type: "button",
      className: "Button Button--ua-reset ListingImageUploader-add",
      icon: "fas fa-plus",
      onclick: e => {
        e.stopPropagation();
        this.fileInput?.click();
      },
      "aria-label": app.translator.trans('flarum-classifieds.forum.uploader.add')
    }, m("span", {
      className: "ListingImageUploader-addLabel"
    }, app.translator.trans('flarum-classifieds.forum.uploader.add'))))), total > 0 && m("div", {
      className: "ListingImageUploader-counter"
    }, total, " / ", max));
  }
  acceptFiles(files) {
    if (!files.length) return;
    const max = this.attrs.max ?? 20;
    const remaining = Math.max(0, max - this.attrs.uploaded.length - this.attrs.pending.length);
    const valid = [];
    let invalidMime = 0;
    let tooLarge = 0;
    for (const file of files.slice(0, remaining)) {
      if (!ALLOWED_MIMES.includes(file.type)) {
        invalidMime++;
        continue;
      }
      if (file.size > MAX_BYTES) {
        tooLarge++;
        continue;
      }
      valid.push({
        file,
        previewUrl: URL.createObjectURL(file)
      });
    }
    if (invalidMime) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('flarum-classifieds.forum.uploader.invalid_type'));
    }
    if (tooLarge) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('flarum-classifieds.forum.uploader.too_large'));
    }
    if (valid.length) {
      this.attrs.onChangePending([...this.attrs.pending, ...valid]);
    }
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ListingImageUploader', ListingImageUploader);